export default __webpack_public_path__ + "static/media/menu_close_okara.62576edf.svg";